import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface ModalState {
  isOpen: boolean;
  data?: string[];
  position?: {
    top: number;
    left: number;
  };
}

@Injectable({
  providedIn: 'root'
})
export class TenantModalService {
  private modalStateSubject = new BehaviorSubject<ModalState | null>(null);
  modalState$ = this.modalStateSubject.asObservable();



  openModal(data: string[]): void {
    this.modalStateSubject.next({
      isOpen: true,
      data
    });
  }

  closeModal(): void {
    this.modalStateSubject.next({
      isOpen: false
    });
  }

}
